import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApprovalRequest, ApprovalStatus } from '../../models';
import { ApprovalRequestStatus } from '../../models/approval-request-status';

@Injectable({
  providedIn: 'root'
})
export class ApprovalRequestService extends UzurvRestService {
  readonly resourceUrl = 'approvalRequests/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Lists approval request statuses
   * @permission approval_request_read
   *
   */
  listAllApprovalRequestStatuses(): Observable<Array<ApprovalRequestStatus>> {
    return this.get<Array<ApprovalRequestStatus>>(`${this.resourceUrl}approvalRequestStatuses/`, {
      pageNumber: 0,
      pageSize: 100
    }).pipe(map(response => Deserialize(response, ApprovalRequestStatus)));
  }

  /**
   * Find active approval request
   * @permission approval_request_read
   *
   */
  findActiveByReviewerUserIdObjectIdAndApprovalType(
    userId: number,
    objectId: number,
    approvalRequestType: string
  ): Observable<ApprovalRequest> {
    return this.get<ApprovalRequest>(`${this.resourceUrl}`, {
      userId: userId,
      objectId: objectId,
      approvalRequestType: approvalRequestType
    }).pipe(map(response => Deserialize(response, ApprovalRequest)));
  }

  /**
   * Update approval
   * @param id
   * @param approval
   * @permission approval_update
   */
  update(id: number, approval: ApprovalRequest): Observable<ApprovalRequest> {
    return this.put<ApprovalRequest>(`${this.resourceUrl}${id}`, Serialize(approval)).pipe(
      map(response => Deserialize(response, ApprovalRequest))
    );
  }
}
